export const sortBy = (propName = 'name') => {
  return (el1: any, el2: any) => {
    const nameA = el1?.[propName]
    const nameB = el2?.[propName]
    if (nameA < nameB) return -1
    if (nameA > nameB) return 1
    return 0
  }
}
